import { RESET_PDP_STATE } from '../constants';

export default () => {
    return (dispatch) =>
        dispatch({
            type: RESET_PDP_STATE,
        });
};
